<template>
	<div class="faqs-page">
		<header-block title="FAQs" :allowBack="true"></header-block>
		<CustomerLoadWait :customer="customer" />

		<transition>
			<div v-if="customer" class="faqs-page-content">
				<FaqsSection :faqs="faqs"/>
			</div>
		</transition>
	</div>
</template>

<script>
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import FaqsSection from './FaqsSection.vue';

export default {
	name: 'FaqsPage',
	mixins: [Services],
	components: {
		CustomerLoadWait,
		HeaderBlock,
		FaqsSection
	},
	data() {
		return {
			faqs: []
		};
	},
	mounted() {
		this._getCustomer();
		const faqName = this.$route.query.name;
		if (faqName) {
			this._getFaqs(faqName, (result) => {
				this.faqs = result?.faqItems || [];
			});
		}
	}
};
</script>

<style scoped>
.faqs-page {
	min-height: 100%;
}

.faqs-page-content {
	padding: 0 20px;
	margin-left: -20px;
	margin-right: -20px;
}
</style>
